<template>
  <div><div class="page-header"><h2><span class="breadcrumb-level">会员管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">会员信息</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">会员介绍页</span></h2></div>
    <el-form :model="form" label-width="120px">
      <el-form-item label="介绍内容">
        <RichTextEditor v-model="form.member_intro" />
      </el-form-item>
      <el-form-item><el-button type="primary" @click="handleSave" :loading="saving">保存</el-button></el-form-item>
    </el-form>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted } from 'vue';import { ElMessage } from 'element-plus';import RichTextEditor from '../../components/RichTextEditor.vue';import * as api from '../../api/userExtensions';
const form=reactive({member_intro:''});const saving=ref(false);
const fetchData=async()=>{try{const r=await api.getMembershipSettings();const d=r.data||{};if(d.member_intro) form.member_intro=d.member_intro.value||''}catch{}};
const handleSave=async()=>{saving.value=true;try{await api.updateMembershipSettings({member_intro:form.member_intro});ElMessage.success('保存成功')}catch{}finally{saving.value=false}};
onMounted(fetchData);
</script>
